import $ from 'jquery';
import abTestService from '../services/abTestService';

const getTestNameFromVariation = (variationNo, variationYes) => {
	      const activeTestVariation = abTestService.isVariationActive(variationNo) ? variationNo : variationYes;
	
	      if (!abTestService.getPossibleTestVariationsData()[activeTestVariation]) {
		      return '';
	      }
	
	      return abTestService.getPossibleTestVariationsData()[activeTestVariation].test;
      },

      initPaymentInstallmentsTestForArrangementPage = () => {
	      if (!abTestService.isAnyVariationActive(['showPaymentInstallmentsInfo_no', 'showPaymentInstallmentsInfo_yes'])) {
		      return;
	      }
		  
	      const $showPayableInInstallments = $('.showPayableInInstallments'),
	            testName = getTestNameFromVariation('showPaymentInstallmentsInfo_no', 'showPaymentInstallmentsInfo_yes');
	
	      if ($showPayableInInstallments.length) {
		      abTestService.sendImpression(testName);
	      }
	
	      $('.packages-table .package-bookBtn').on(
		      'mousedown',
		      () => abTestService.sendEvent(testName, 'ticketCategorySelect')
	      );
      },

      initPaymentInstallmentsTestForArrangementList = () => {
	      const $filteredArrangementsContainer = $('.filteredArrangementsContainer'),
	            $showPayableInInstallments = $('.showPayableInInstallments'),
	            testName = getTestNameFromVariation('showPaymentInstallmentsInfo_no', 'showPaymentInstallmentsInfo_yes');
	
	      if (!$filteredArrangementsContainer.length ||
		      !abTestService.isAnyVariationActive(['showPaymentInstallmentsInfo_no', 'showPaymentInstallmentsInfo_yes'])
	      ) {
		      return;
	      }
	
	      if ($showPayableInInstallments.length) {
		      abTestService.sendImpression(testName);
	      }
	
	      $filteredArrangementsContainer.on(
		      'mousedown',
		      '.arrangementListItem-matchName, .arrangementListItem-logos-wrapper, .bookBtn',
		      () => abTestService.sendEvent(testName, 'arrangementLinkClicked')
	      );
      },

	  initPaginatorVsLoadMoreBtnTest = () => {
		const testName = getTestNameFromVariation('showLoadMoreButton_no', 'showLoadMoreButton_yes');

		if (testName) {
			abTestService.sendEvent(testName, 'openClubPage');
			$('.page-link').on('click', () => {
				abTestService.sendEvent(testName, 'clickedOnPaginatorElement');
			});
		}
	  },

	  /**
	   * @param {string} eventName
	   * @param {boolean} isImpressionEvent
	   */
	  initVBTHomepageAboveTheFoldTest = (eventName, isImpressionEvent = false) => {
		const testName = getTestNameFromVariation('redesignedHomepageAboveTheFold_no', 'redesignedHomepageAboveTheFold_yes');

		if (testName) {
            if (isImpressionEvent) {
                abTestService.sendImpression(testName);
            }

            abTestService.sendEvent(testName, eventName);
		}
	  };

export {
	getTestNameFromVariation,
	initPaymentInstallmentsTestForArrangementList,
	initPaymentInstallmentsTestForArrangementPage,
	initPaginatorVsLoadMoreBtnTest,
	initVBTHomepageAboveTheFoldTest
};